import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { Compass } from 'lucide-react';

import { Button } from '@/components/ui/buttons';
import { EmptyState } from '@/components/ui/feedback';
import { ICON_SIZE } from '@/components/ui/iconSize';
import { DEFAULT_ROUTE } from '@/config/routes';

/** Shows the not-found message with a link to the start page. */
export function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <EmptyState
      icon={<Compass size={ICON_SIZE.xxl} />}
      title={t('notFound.description')}
      plain
      className="min-h-error-page"
      action={
        <Button onClick={() => navigate(DEFAULT_ROUTE)}>{t('notFound.action')}</Button>
      }
    />
  );
}
